"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
let Notification = exports.Notification = void 0;
(function (_Notification) {
  let Style = /*#__PURE__*/function (Style) {
    Style["SUCCESS"] = "success";
    Style["INFO"] = "info";
    Style["WARNING"] = "warning";
    Style["DANGER"] = "danger";
    return Style;
  }({});
  _Notification.Style = Style;
})(Notification || (exports.Notification = Notification = {}));